/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Usage_Tab_ResetsInputs */



/**
* | output |
* | --- |
* | "Resets {date}" |
*
* @param {Usage_Tab_ResetsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_tab_resets = /** @type {((inputs: Usage_Tab_ResetsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Tab_ResetsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Setzt zurück am ${i?.date}`)
	return /** @type {LocalizedString} */ (`Resets ${i?.date}`)
});